// extracted by mini-css-extract-plugin
export var actions = "_t0-4";
export var item = "_t0-1";
export var price = "_t0-3";
export var quantity = "_t0-2";
export var table = "_t0-0";